import { useState } from 'react';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import CheckList from '../../CheckList/CheckList';
import styles from './ApplicabilityModal.module.scss';

const initialState = {
	selectedList: [],
	query: '',
};
const HEADING = 'Select Non applicable Product';
const NonApplicableProductsModal = (props) => {
	const {
		toggleNonApplicableProductsModal,
		show,
		products,
		selectedProdList,
	} = props;
	const [state, setState] = useState(cloneDeep(initialState));
	const { selectedList } = state;
	const handleClose = () => {
		setState({
			...state,
			selectedList: [],
			query: '',
		});
		toggleNonApplicableProductsModal(false);
	};
	const handleClick = (idx) => {
		if (selectedList.includes(idx)) {
			const newSelectedList = selectedList.filter((id) => {
				return id !== idx;
			});
			setState({
				...state,
				selectedList: newSelectedList,
			});
		} else {
			const newSelectedList = selectedList;
			newSelectedList.push(idx);
			setState({
				...state,
				selectedList: newSelectedList,
			});
		}
	};

	const handleConfirm = () => {
		const ids = [];
		for (let idx = 0; idx < selectedList.length; idx++) {
			ids.push(products[selectedList[idx]]);
		}
		const list = products.filter((obj) => {
			return selectedList.includes(obj.id);
		});
		props.handleConfirm(list, 'nonapplicableProducts');
		toggleNonApplicableProductsModal(false);
		setState({
			...state,
			selectedList: [],
		});
	};
	const handleSearchInput = (queryString) => {
		setState({
			...state,
			query: queryString,
		});
	};

	const generateList = () => {
		return products
			.filter((obj) => {
				return (
					!selectedProdList.find((selectedProd) => {
						return selectedProd.id === parseInt(obj.id, 10);
					}) &&
					obj.productName
						.toLowerCase()
						.indexOf(state.query.trim().toLowerCase()) !== -1
				);
			})
			.map((obj) => {
				const name = obj.productName ? `${obj.productName}` : '';
				return {
					id: parseInt(obj.id, 10),
					title: name,
				};
			});
	};

	return (
		<BaseModal
			heading={HEADING}
			open={show}
			handleClose={handleClose}
			handleConfirm={handleConfirm}
		>
			<div className={`${styles.root}`}>
				<CheckList
					list={generateList()}
					selectedItems={state.selectedList}
					handleItemSelect={handleClick}
					showSearch
					handleSearchInput={handleSearchInput}
					placeholder='Search Product'
				/>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const products = state.form.ALL_PRODUCTS.data.LIST;
	const { data, show } = state.modal.nonapplicable_products;
	return {
		show,
		data,
		products,
	};
};
NonApplicableProductsModal.defaultProps = {
	selectedProdList: [],
	show: false,
};

const mapDispatchToProps = {
	toggleNonApplicableProductsModal:
		modalActions.toggleNonApplicableProductsModal,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NonApplicableProductsModal);
